import { Component } from '@angular/core';

@Component({
  selector: 'ng-responsive-nav',
  templateUrl: './ng-responsive-nav.component.html',
  styleUrls: ['./ng-responsive-nav.component.scss']
})
export class NgResponsiveNavComponent {}
